import type { Results } from 'payments-lib-types';
import { type FC, type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ThemeMode } from '@/helpers/enums';
import type { PaymentMethod as PaymentMethodI } from '@/store';
import type { ProfileInfoConfig } from './config';
import { ProfileInfoForm } from './ProfileInfoForm';

enum ProfileInfoStep {
  PROFILE_INFO = '1',
  PAYMENT_INFO = '2',
}

interface IPaymentMethodStepsProps {
  methodFields: Results.GetMethodFieldsResult;
  paymentMethod: PaymentMethodI | null;
  mode?: ThemeMode;
  config: ProfileInfoConfig;
  country?: string;
  renderPaymentInfo: () => ReactNode;
}

export const PaymentMethodSteps: FC<IPaymentMethodStepsProps> = ({
  methodFields,
  paymentMethod,
  mode,
  config,
  country,
  renderPaymentInfo,
}) => {
  const { t } = useTranslation('deposits');
  const [currentStep, setCurrentStep] = useState(ProfileInfoStep.PROFILE_INFO);

  return (
    <>
      <div className="title">
        <span className="title-steps">
          <h3>{currentStep}</h3>
          <h3 className="total-steps">/2</h3>
        </span>
        <h3>
          {currentStep === ProfileInfoStep.PROFILE_INFO
            ? t('paymentMethodPersonalInfoTitle')
            : paymentMethod?.title}
        </h3>
      </div>
      {currentStep === ProfileInfoStep.PROFILE_INFO ? (
        <ProfileInfoForm
          config={config}
          country={country}
          methodFields={methodFields}
          mode={mode}
          onSuccess={() => setCurrentStep(ProfileInfoStep.PAYMENT_INFO)}
          paymentMethod={paymentMethod}
        />
      ) : (
        renderPaymentInfo()
      )}
    </>
  );
};
